import { withStyles } from '@material-ui/core';

import Selection from './component';
import styles from './styles';

export default withStyles(styles)(Selection);
